// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ================================
   Theme (aligned with ApplyForm)
================================ */
:root {
  --bg-card: linear-gradient(180deg, #ffffff, #fbfbff);
  --panel-border: rgba(99, 102, 241, 0.06);
  --muted: #6b7280;
  --text: #0f172a;
  --accent-500: #6366f1;
  --accent-600: #4f46e5;
  --accent-700: #4338ca;
  --success: #10b981;
  --danger: #ef4444;
  --radius: 14px;
  --shadow-soft: 0 18px 40px rgba(15, 23, 42, 0.08);
  --shadow-sm: 0 10px 26px rgba(15, 23, 42, 0.06);
}

/* ================================
   OUTER CARD (after login only)
================================ */
.admin-card {
  max-width: 1240px;
  margin: 2rem auto;
  padding: 1.5rem 1.75rem;
  border-radius: var(--radius);
  background: linear-gradient(180deg, #ffffff, #f3f4ff);
  border: 1px solid var(--panel-border);
  box-shadow: var(--shadow-soft);
  color: var(--text);
}

/* after login -> full width */
.admin-card--after-login {
  max-width: 1240px !important;
}

/* (no longer used, but harmless to keep)
.admin-card--before-login {
  max-width: 420px !important;
}
*/

/* ================================
   LOGIN — stand-alone card
================================ */
.admin-login {
  width: 100%;
  max-width: 320px;
  margin: 3.5rem auto;
  text-align: left;
  display: flex;
  flex-direction: column;
  gap: 0.9rem;
  padding: 2.3rem 2.2rem 2.4rem;
  border-radius: 16px;
  border: 1px solid rgba(148, 163, 184, 0.35);
  background: linear-gradient(180deg, #ffffff, #f9fafb);
  box-shadow: var(--shadow-sm);
  text-align: center;
}

.admin-login .section-title {
  font-size: 1.35rem;
  font-weight: 800;
  margin: 1.5rem 0;
  letter-spacing: -0.02em;
  color: var(--text);
}

.admin-login .section-subtitle {
  margin: 0.2rem 0 0.6rem;
  font-size: 0.88rem;
  color: var(--muted);
}

.admin-login .input {
  width: 100%;
  padding: 0.72rem 0.95rem;
  border-radius: 10px;
  border: 1px solid rgba(148, 163, 184, 0.6);
  font-size: 0.94rem;
  outline: none;
  transition: border 0.14s ease, box-shadow 0.14s ease, transform 0.1s ease;
  background: #ffffff;
}

.admin-login .input:focus {
  border-color: var(--accent-600);
  box-shadow: 0 0 0 1px rgba(129, 140, 248, 0.6),
    0 16px 32px rgba(79, 70, 229, 0.18);
  transform: translateY(-1px);
}

.admin-login .actions {
  width: 100%;
  margin-top: 0.2rem;
}

.admin-login .btn-primary {
  width: 100%;
  padding: 0.8rem;
  font-size: 0.98rem;
  font-weight: 700;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background: var(--accent-700);
  color: #fff;
  border: none;
  border-radius: 0.6rem;
  cursor: pointer;
}

@media (max-width: 480px) {
  .admin-login {
    max-width: 92%;
    margin: 2.5rem auto;
  }
}

/* ================================
   ADMIN PANEL LAYOUT
================================ */
.admin-panel {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

/* Header section */
.admin-header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 1rem;
  margin-bottom: 0.5rem;
}

.admin-title {
  margin: 0;
  font-size: 1.4rem;
  letter-spacing: -0.02em;
}

.admin-subtitle {
  margin: 0.2rem 0 0;
  font-size: 0.9rem;
  color: var(--muted);
}

.admin-summary {
  display: inline-flex;
  flex-wrap: wrap;
  gap: 0.4rem;
  align-items: center;
}

.summary-pill {
  padding: 0.25rem 0.7rem;
  border-radius: 999px;
  font-size: 0.8rem;
  border: 1px solid rgba(148, 163, 184, 0.6);
  background: rgba(248, 250, 252, 0.9);
  color: #4b5563;
}

/* ================================
   TABS
================================ */
.admin-tabs {
  display: flex;
  gap: 0.5rem;
  margin-bottom: 1rem;
  /* border-bottom: 2px solid #e5e7eb; */
  padding-bottom: 0;
}

.tab-btn {
  padding: 0.65rem 1.2rem;
  background: transparent;
  border: none;
  border-bottom: 3px solid transparent;
  font-size: 0.95rem;
  font-weight: 600;
  color: var(--muted);
  cursor: pointer;
  transition: all 0.2s ease;
  position: relative;
  bottom: -2px;
}

.tab-btn:hover {
  color: var(--accent-600);
}

.tab-btn.active {
  color: var(--accent-600);
  border-bottom-color: var(--accent-600);
}

/* ================================
   CONTROLS (filter + buttons)
================================ */
.admin-controls {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 0.75rem;
  padding: 0.75rem 0.9rem;
  border-radius: 14px;
  background: linear-gradient(90deg, #eef2ff, #f9fafb);
  border: 1px solid rgba(148, 163, 184, 0.35);
}

.select-wrap {
  display: flex;
  flex-direction: column;
  gap: 0.3rem;
}

.select-label {
  font-size: 0.82rem;
  font-weight: 600;
  color: var(--muted);
}

.select-wrap .select {
  padding: 0.52rem 0.75rem;
  border-radius: 10px;
  border: 1px solid rgba(148, 163, 184, 0.7);
  font-size: 0.9rem;
  background: #ffffff;
  min-width: 160px;
}

/* Buttons */
.btn-group {
  display: flex;
  gap: 0.5rem;
  flex-wrap: wrap;
}

.btn-outline,
.btn-success {
  padding: 0.55rem 0.9rem;
  border-radius: 999px;
  font-size: 0.86rem;
  font-weight: 600;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  gap: 0.4rem;
  transition: transform 0.12s ease, box-shadow 0.12s ease, filter 0.12s ease;
}

.btn-outline {
  border: 1px solid var(--accent-500);
  background: #ffffff;
  color: var(--accent-600);
}

.btn-outline:hover {
  transform: translateY(-1px);
}

.btn-success {
  background: var(--accent-600) !important;
  color: #fff;
  border: none;
}

.btn-success:hover {
  transform: translateY(-1px);
  filter: brightness(1.04);
}

/* ================================
   TABLE CARD
================================ */
.table-card {
  border-radius: 16px;
  background: #ffffff;
  border: 1px solid rgba(226, 232, 240, 0.9);
  box-shadow: var(--shadow-sm);
  overflow: hidden;
}

.table-wrap {
  overflow: auto;
}

.app-table {
  width: 100%;
  min-width: 900px;
  border-collapse: collapse;
  background: #ffffff;
}

.app-table thead th {
  padding: 0.85rem 0.9rem;
  background: #f9fafb;
  border-bottom: 1px solid #e5e7eb;
  text-align: center;
  font-weight: 700;
  font-size: 0.86rem;
  color: #111827;
  position: sticky;
  top: 0;
  z-index: 1;
}

.app-table tbody td {
  padding: 0.8rem 0.9rem;
  border-bottom: 1px solid #f3f4f6;
  color: #374151;
  font-size: 0.86rem;
  vertical-align: middle;
  background: #ffffff;
  text-align: center !important;
}

/* badge for eligible */
.badge {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 0.18rem 0.6rem;
  border-radius: 999px;
  font-size: 0.78rem;
  font-weight: 600;
}
.badge--yes {
  background: rgba(34, 197, 94, 0.12);
  color: #15803d;
}
.badge--no {
  background: rgba(248, 113, 113, 0.12);
  color: #b91c1c;
}

/* ACTIONS COLUMN */
.actions-col {
  text-align: right;
  padding-right: 0.9rem;
}

.actions-col-inner {
  display: inline-flex;
  gap: 0.4rem;
  align-items: center;
  justify-content: flex-end;
}

/* Tiny buttons (also used in Pagination) */
.tiny-btn {
  padding: 0.3rem 0.55rem;
  background: #ffffff;
  border: 1px solid #e5e7eb;
  border-radius: 999px;
  font-size: 0.8rem;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  gap: 0.25rem;
  transition: background 0.12s ease, box-shadow 0.12s ease, transform 0.12s ease,
    border 0.12s ease;
}

.tiny-btn:hover:not(.disabled) {
  background: #f9fafb;
  box-shadow: 0 8px 18px rgba(148, 163, 184, 0.4);
  transform: translateY(-1px);
}

.tiny-btn.outline {
  background: transparent;
  border: 1px solid #cbd5e1;
  text-decoration: none;
  color: #111827;
}

/* Pagination styles */
.pagination-wrapper .tiny-btn.active {
  background: linear-gradient(135deg, var(--accent-500), var(--accent-600));
  color: #ffffff;
  border-color: transparent;
}

.pagination-wrapper .tiny-btn.disabled,
.pagination-wrapper .tiny-btn:disabled {
  opacity: 0.55;
  cursor: default;
  box-shadow: none;
  transform: none;
  background: #ffffff;
}

.pagination-wrapper {
  display: flex;
  align-items: center;
  gap: 0.4rem;
  flex-wrap: wrap;
}

.pagination-wrapper .select {
  padding: 0.3rem 0.55rem;
  border-radius: 999px;
  border: 1px solid #cbd5e1;
  background: #ffffff;
  font-size: 0.8rem;
}

/* Footer info */
.admin-footer {
  margin-top: 0.85rem;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.75rem;
  flex-wrap: wrap;
}

.admin-range {
  color: var(--muted);
  font-size: 0.82rem;
}

/* Helpers */
.mono {
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas,
    "Liberation Mono", "Courier New", monospace;
}
.muted {
  color: var(--muted);
}
.empty {
  padding: 1rem;
  text-align: center;
  color: var(--muted);
  font-size: 0.9rem;
}

@media (max-width: 900px) {
  .admin-controls {
    flex-direction: column;
    align-items: stretch;
  }
  .admin-header {
    flex-direction: column;
  }
}

@media (max-width: 640px) {
  .admin-card {
    padding: 1.1rem 1rem;
  }
  .table-card {
    border-radius: 12px;
  }
}

/* ================================
   Password eye icon in login
================================ */

.password-field {
  position: relative;
}

.password-field .input {
  padding-right: 2.5rem; /* space for eye icon */
}

.password-toggle {
  position: absolute;
  top: 50%;
  right: 0.75rem;
  transform: translateY(-50%);
  background: transparent;
  border: none;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: 1.1rem;
  color: var(--muted);
  padding: 0;
}

`, "",{"version":3,"sources":["webpack://./src/styles/AdminDashboard.css"],"names":[],"mappings":"AAAA;;kCAEkC;AAClC;EACE,oDAAoD;EACpD,wCAAwC;EACxC,gBAAgB;EAChB,eAAe;EACf,qBAAqB;EACrB,qBAAqB;EACrB,qBAAqB;EACrB,kBAAkB;EAClB,iBAAiB;EACjB,cAAc;EACd,iDAAiD;EACjD,+CAA+C;AACjD;;AAEA;;kCAEkC;AAClC;EACE,iBAAiB;EACjB,iBAAiB;EACjB,uBAAuB;EACvB,4BAA4B;EAC5B,qDAAqD;EACrD,qCAAqC;EACrC,8BAA8B;EAC9B,kBAAkB;AACpB;;AAEA,8BAA8B;AAC9B;EACE,4BAA4B;AAC9B;;AAEA;;;;CAIC;;AAED;;kCAEkC;AAClC;EACE,WAAW;EACX,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,6BAA6B;EAC7B,mBAAmB;EACnB,2CAA2C;EAC3C,qDAAqD;EACrD,4BAA4B;EAC5B,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,uBAAuB;EACvB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,wBAAwB;EACxB,mBAAmB;EACnB,0CAA0C;EAC1C,kBAAkB;EAClB,aAAa;EACb,yEAAyE;EACzE,mBAAmB;AACrB;;AAEA;EACE,+BAA+B;EAC/B;uCACqC;EACrC,2BAA2B;AAC7B;;AAEA;EACE,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,6BAA6B;EAC7B,WAAW;EACX,YAAY;EACZ,qBAAqB;EACrB,eAAe;AACjB;;AAEA;EACE;IACE,cAAc;IACd,mBAAmB;EACrB;AACF;;AAEA;;kCAEkC;AAClC;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA,mBAAmB;AACnB;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,SAAS;EACT,qBAAqB;AACvB;;AAEA;EACE,SAAS;EACT,iBAAiB;EACjB,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,eAAe;EACf,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;EACvB,oBAAoB;EACpB,iBAAiB;EACjB,0CAA0C;EAC1C,oCAAoC;EACpC,cAAc;AAChB;;AAEA;;kCAEkC;AAClC;EACE,aAAa;EACb,WAAW;EACX,mBAAmB;EACnB,sCAAsC;EACtC,iBAAiB;AACnB;;AAEA;EACE,uBAAuB;EACvB,uBAAuB;EACvB,YAAY;EACZ,oCAAoC;EACpC,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,wBAAwB;EACxB,sCAAsC;AACxC;;AAEA;;kCAEkC;AAClC;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,eAAe;EACf,YAAY;EACZ,uBAAuB;EACvB,mBAAmB;EACnB,oDAAoD;EACpD,2CAA2C;AAC7C;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,wBAAwB;EACxB,mBAAmB;EACnB,0CAA0C;EAC1C,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA,YAAY;AACZ;EACE,aAAa;EACb,WAAW;EACX,eAAe;AACjB;;AAEA;;EAEE,uBAAuB;EACvB,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;EACX,0EAA0E;AAC5E;;AAEA;EACE,mCAAmC;EACnC,mBAAmB;EACnB,wBAAwB;AAC1B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,wCAAwC;EACxC,WAAW;EACX,YAAY;AACd;;AAEA;EACE,2BAA2B;EAC3B,wBAAwB;AAC1B;;AAEA;;kCAEkC;AAClC;EACE,mBAAmB;EACnB,mBAAmB;EACnB,0CAA0C;EAC1C,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;EACvB,mBAAmB;EACnB,gCAAgC;EAChC,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,cAAc;EACd,gBAAgB;EAChB,MAAM;EACN,UAAU;AACZ;;AAEA;EACE,sBAAsB;EACtB,gCAAgC;EAChC,cAAc;EACd,kBAAkB;EAClB,sBAAsB;EACtB,mBAAmB;EACnB,6BAA6B;AAC/B;;AAEA,uBAAuB;AACvB;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,uBAAuB;EACvB,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,mCAAmC;EACnC,cAAc;AAChB;AACA;EACE,qCAAqC;EACrC,cAAc;AAChB;;AAEA,mBAAmB;AACnB;EACE,iBAAiB;EACjB,qBAAqB;AACvB;;AAEA;EACE,oBAAoB;EACpB,WAAW;EACX,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA,2CAA2C;AAC3C;EACE,uBAAuB;EACvB,mBAAmB;EACnB,yBAAyB;EACzB,oBAAoB;EACpB,iBAAiB;EACjB,eAAe;EACf,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;EACZ;qBACmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,+CAA+C;EAC/C,2BAA2B;AAC7B;;AAEA;EACE,uBAAuB;EACvB,yBAAyB;EACzB,qBAAqB;EACrB,cAAc;AAChB;;AAEA,sBAAsB;AACtB;EACE,yEAAyE;EACzE,cAAc;EACd,yBAAyB;AAC3B;;AAEA;;EAEE,aAAa;EACb,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,uBAAuB;EACvB,oBAAoB;EACpB,yBAAyB;EACzB,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA,gBAAgB;AAChB;EACE,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA,YAAY;AACZ;EACE;+CAC6C;AAC/C;AACA;EACE,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,kBAAkB;EAClB,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE;IACE,sBAAsB;IACtB,oBAAoB;EACtB;EACA;IACE,sBAAsB;EACxB;AACF;;AAEA;EACE;IACE,oBAAoB;EACtB;EACA;IACE,mBAAmB;EACrB;AACF;;AAEA;;kCAEkC;;AAElC;EACE,kBAAkB;AACpB;;AAEA;EACE,qBAAqB,EAAE,uBAAuB;AAChD;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,cAAc;EACd,2BAA2B;EAC3B,uBAAuB;EACvB,YAAY;EACZ,eAAe;EACf,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,mBAAmB;EACnB,UAAU;AACZ","sourcesContent":["/* ================================\n   Theme (aligned with ApplyForm)\n================================ */\n:root {\n  --bg-card: linear-gradient(180deg, #ffffff, #fbfbff);\n  --panel-border: rgba(99, 102, 241, 0.06);\n  --muted: #6b7280;\n  --text: #0f172a;\n  --accent-500: #6366f1;\n  --accent-600: #4f46e5;\n  --accent-700: #4338ca;\n  --success: #10b981;\n  --danger: #ef4444;\n  --radius: 14px;\n  --shadow-soft: 0 18px 40px rgba(15, 23, 42, 0.08);\n  --shadow-sm: 0 10px 26px rgba(15, 23, 42, 0.06);\n}\n\n/* ================================\n   OUTER CARD (after login only)\n================================ */\n.admin-card {\n  max-width: 1240px;\n  margin: 2rem auto;\n  padding: 1.5rem 1.75rem;\n  border-radius: var(--radius);\n  background: linear-gradient(180deg, #ffffff, #f3f4ff);\n  border: 1px solid var(--panel-border);\n  box-shadow: var(--shadow-soft);\n  color: var(--text);\n}\n\n/* after login -> full width */\n.admin-card--after-login {\n  max-width: 1240px !important;\n}\n\n/* (no longer used, but harmless to keep)\n.admin-card--before-login {\n  max-width: 420px !important;\n}\n*/\n\n/* ================================\n   LOGIN — stand-alone card\n================================ */\n.admin-login {\n  width: 100%;\n  max-width: 320px;\n  margin: 3.5rem auto;\n  text-align: left;\n  display: flex;\n  flex-direction: column;\n  gap: 0.9rem;\n  padding: 2.3rem 2.2rem 2.4rem;\n  border-radius: 16px;\n  border: 1px solid rgba(148, 163, 184, 0.35);\n  background: linear-gradient(180deg, #ffffff, #f9fafb);\n  box-shadow: var(--shadow-sm);\n  text-align: center;\n}\n\n.admin-login .section-title {\n  font-size: 1.35rem;\n  font-weight: 800;\n  margin: 1.5rem 0;\n  letter-spacing: -0.02em;\n  color: var(--text);\n}\n\n.admin-login .section-subtitle {\n  margin: 0.2rem 0 0.6rem;\n  font-size: 0.88rem;\n  color: var(--muted);\n}\n\n.admin-login .input {\n  width: 100%;\n  padding: 0.72rem 0.95rem;\n  border-radius: 10px;\n  border: 1px solid rgba(148, 163, 184, 0.6);\n  font-size: 0.94rem;\n  outline: none;\n  transition: border 0.14s ease, box-shadow 0.14s ease, transform 0.1s ease;\n  background: #ffffff;\n}\n\n.admin-login .input:focus {\n  border-color: var(--accent-600);\n  box-shadow: 0 0 0 1px rgba(129, 140, 248, 0.6),\n    0 16px 32px rgba(79, 70, 229, 0.18);\n  transform: translateY(-1px);\n}\n\n.admin-login .actions {\n  width: 100%;\n  margin-top: 0.2rem;\n}\n\n.admin-login .btn-primary {\n  width: 100%;\n  padding: 0.8rem;\n  font-size: 0.98rem;\n  font-weight: 700;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  background: var(--accent-700);\n  color: #fff;\n  border: none;\n  border-radius: 0.6rem;\n  cursor: pointer;\n}\n\n@media (max-width: 480px) {\n  .admin-login {\n    max-width: 92%;\n    margin: 2.5rem auto;\n  }\n}\n\n/* ================================\n   ADMIN PANEL LAYOUT\n================================ */\n.admin-panel {\n  display: flex;\n  flex-direction: column;\n  gap: 1rem;\n}\n\n/* Header section */\n.admin-header {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 1rem;\n  margin-bottom: 0.5rem;\n}\n\n.admin-title {\n  margin: 0;\n  font-size: 1.4rem;\n  letter-spacing: -0.02em;\n}\n\n.admin-subtitle {\n  margin: 0.2rem 0 0;\n  font-size: 0.9rem;\n  color: var(--muted);\n}\n\n.admin-summary {\n  display: inline-flex;\n  flex-wrap: wrap;\n  gap: 0.4rem;\n  align-items: center;\n}\n\n.summary-pill {\n  padding: 0.25rem 0.7rem;\n  border-radius: 999px;\n  font-size: 0.8rem;\n  border: 1px solid rgba(148, 163, 184, 0.6);\n  background: rgba(248, 250, 252, 0.9);\n  color: #4b5563;\n}\n\n/* ================================\n   TABS\n================================ */\n.admin-tabs {\n  display: flex;\n  gap: 0.5rem;\n  margin-bottom: 1rem;\n  /* border-bottom: 2px solid #e5e7eb; */\n  padding-bottom: 0;\n}\n\n.tab-btn {\n  padding: 0.65rem 1.2rem;\n  background: transparent;\n  border: none;\n  border-bottom: 3px solid transparent;\n  font-size: 0.95rem;\n  font-weight: 600;\n  color: var(--muted);\n  cursor: pointer;\n  transition: all 0.2s ease;\n  position: relative;\n  bottom: -2px;\n}\n\n.tab-btn:hover {\n  color: var(--accent-600);\n}\n\n.tab-btn.active {\n  color: var(--accent-600);\n  border-bottom-color: var(--accent-600);\n}\n\n/* ================================\n   CONTROLS (filter + buttons)\n================================ */\n.admin-controls {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  flex-wrap: wrap;\n  gap: 0.75rem;\n  padding: 0.75rem 0.9rem;\n  border-radius: 14px;\n  background: linear-gradient(90deg, #eef2ff, #f9fafb);\n  border: 1px solid rgba(148, 163, 184, 0.35);\n}\n\n.select-wrap {\n  display: flex;\n  flex-direction: column;\n  gap: 0.3rem;\n}\n\n.select-label {\n  font-size: 0.82rem;\n  font-weight: 600;\n  color: var(--muted);\n}\n\n.select-wrap .select {\n  padding: 0.52rem 0.75rem;\n  border-radius: 10px;\n  border: 1px solid rgba(148, 163, 184, 0.7);\n  font-size: 0.9rem;\n  background: #ffffff;\n  min-width: 160px;\n}\n\n/* Buttons */\n.btn-group {\n  display: flex;\n  gap: 0.5rem;\n  flex-wrap: wrap;\n}\n\n.btn-outline,\n.btn-success {\n  padding: 0.55rem 0.9rem;\n  border-radius: 999px;\n  font-size: 0.86rem;\n  font-weight: 600;\n  cursor: pointer;\n  display: inline-flex;\n  align-items: center;\n  gap: 0.4rem;\n  transition: transform 0.12s ease, box-shadow 0.12s ease, filter 0.12s ease;\n}\n\n.btn-outline {\n  border: 1px solid var(--accent-500);\n  background: #ffffff;\n  color: var(--accent-600);\n}\n\n.btn-outline:hover {\n  transform: translateY(-1px);\n}\n\n.btn-success {\n  background: var(--accent-600) !important;\n  color: #fff;\n  border: none;\n}\n\n.btn-success:hover {\n  transform: translateY(-1px);\n  filter: brightness(1.04);\n}\n\n/* ================================\n   TABLE CARD\n================================ */\n.table-card {\n  border-radius: 16px;\n  background: #ffffff;\n  border: 1px solid rgba(226, 232, 240, 0.9);\n  box-shadow: var(--shadow-sm);\n  overflow: hidden;\n}\n\n.table-wrap {\n  overflow: auto;\n}\n\n.app-table {\n  width: 100%;\n  min-width: 900px;\n  border-collapse: collapse;\n  background: #ffffff;\n}\n\n.app-table thead th {\n  padding: 0.85rem 0.9rem;\n  background: #f9fafb;\n  border-bottom: 1px solid #e5e7eb;\n  text-align: center;\n  font-weight: 700;\n  font-size: 0.86rem;\n  color: #111827;\n  position: sticky;\n  top: 0;\n  z-index: 1;\n}\n\n.app-table tbody td {\n  padding: 0.8rem 0.9rem;\n  border-bottom: 1px solid #f3f4f6;\n  color: #374151;\n  font-size: 0.86rem;\n  vertical-align: middle;\n  background: #ffffff;\n  text-align: center !important;\n}\n\n/* badge for eligible */\n.badge {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  padding: 0.18rem 0.6rem;\n  border-radius: 999px;\n  font-size: 0.78rem;\n  font-weight: 600;\n}\n.badge--yes {\n  background: rgba(34, 197, 94, 0.12);\n  color: #15803d;\n}\n.badge--no {\n  background: rgba(248, 113, 113, 0.12);\n  color: #b91c1c;\n}\n\n/* ACTIONS COLUMN */\n.actions-col {\n  text-align: right;\n  padding-right: 0.9rem;\n}\n\n.actions-col-inner {\n  display: inline-flex;\n  gap: 0.4rem;\n  align-items: center;\n  justify-content: flex-end;\n}\n\n/* Tiny buttons (also used in Pagination) */\n.tiny-btn {\n  padding: 0.3rem 0.55rem;\n  background: #ffffff;\n  border: 1px solid #e5e7eb;\n  border-radius: 999px;\n  font-size: 0.8rem;\n  cursor: pointer;\n  display: inline-flex;\n  align-items: center;\n  gap: 0.25rem;\n  transition: background 0.12s ease, box-shadow 0.12s ease, transform 0.12s ease,\n    border 0.12s ease;\n}\n\n.tiny-btn:hover:not(.disabled) {\n  background: #f9fafb;\n  box-shadow: 0 8px 18px rgba(148, 163, 184, 0.4);\n  transform: translateY(-1px);\n}\n\n.tiny-btn.outline {\n  background: transparent;\n  border: 1px solid #cbd5e1;\n  text-decoration: none;\n  color: #111827;\n}\n\n/* Pagination styles */\n.pagination-wrapper .tiny-btn.active {\n  background: linear-gradient(135deg, var(--accent-500), var(--accent-600));\n  color: #ffffff;\n  border-color: transparent;\n}\n\n.pagination-wrapper .tiny-btn.disabled,\n.pagination-wrapper .tiny-btn:disabled {\n  opacity: 0.55;\n  cursor: default;\n  box-shadow: none;\n  transform: none;\n  background: #ffffff;\n}\n\n.pagination-wrapper {\n  display: flex;\n  align-items: center;\n  gap: 0.4rem;\n  flex-wrap: wrap;\n}\n\n.pagination-wrapper .select {\n  padding: 0.3rem 0.55rem;\n  border-radius: 999px;\n  border: 1px solid #cbd5e1;\n  background: #ffffff;\n  font-size: 0.8rem;\n}\n\n/* Footer info */\n.admin-footer {\n  margin-top: 0.85rem;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 0.75rem;\n  flex-wrap: wrap;\n}\n\n.admin-range {\n  color: var(--muted);\n  font-size: 0.82rem;\n}\n\n/* Helpers */\n.mono {\n  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas,\n    \"Liberation Mono\", \"Courier New\", monospace;\n}\n.muted {\n  color: var(--muted);\n}\n.empty {\n  padding: 1rem;\n  text-align: center;\n  color: var(--muted);\n  font-size: 0.9rem;\n}\n\n@media (max-width: 900px) {\n  .admin-controls {\n    flex-direction: column;\n    align-items: stretch;\n  }\n  .admin-header {\n    flex-direction: column;\n  }\n}\n\n@media (max-width: 640px) {\n  .admin-card {\n    padding: 1.1rem 1rem;\n  }\n  .table-card {\n    border-radius: 12px;\n  }\n}\n\n/* ================================\n   Password eye icon in login\n================================ */\n\n.password-field {\n  position: relative;\n}\n\n.password-field .input {\n  padding-right: 2.5rem; /* space for eye icon */\n}\n\n.password-toggle {\n  position: absolute;\n  top: 50%;\n  right: 0.75rem;\n  transform: translateY(-50%);\n  background: transparent;\n  border: none;\n  cursor: pointer;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 1.1rem;\n  color: var(--muted);\n  padding: 0;\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
